import type { TersaImageModel } from '../../types';
import { providers } from '../../../providers';
import { alibaba } from '../../alibaba';
import { wavespeed } from '../../wavespeed';

// 美元汇率
const RMB_TO_USD = 1 / 6.8;
// rmb to usd 转换
const usd = (rmb: number) => rmb * RMB_TO_USD;
const COST_FACTOR = 1.5;

export const wanModels: Record<string, TersaImageModel> = {
    'wan2.7-image-pro': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: alibaba.image('wan2.7-image-pro'),
                modelBackup_create: [wavespeed.image('alibaba/wan-2.7/text-to-image-pro')],
                model_edit: alibaba.image('wan2.7-image-pro'),
                modelBackup_edit: [wavespeed.image('alibaba/wan-2.7/image-edit-pro')],
                getCost: () => usd(0.5 * COST_FACTOR),
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K', '4K'],
            },
            i2i: {
                sizes: ['match'],
                resolutions: ['1K', '2K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'wan2.7-image': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: alibaba.image('wan2.7-image'),
                modelBackup_create: [wavespeed.image('alibaba/wan-2.7/text-to-image')],
                model_edit: alibaba.image('wan2.7-image'),
                modelBackup_edit: [wavespeed.image('alibaba/wan-2.7/image-edit')],
                getCost: () => usd(0.2 * COST_FACTOR),
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K'],
            },
            i2i: {
                sizes: ['match'],
                resolutions: ['1K', '2K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};